import { h } from 'preact';
import Store from 'store/store';
import { LOCAL_MOVIE_TYPE } from 'utils/constants';
import { isPlaceholder, getMovieType } from 'utils/data';
import { getMovieStatus } from 'utils/movieStatus';
import { getCurrentRegionSettings } from 'utils/studioConfig';
import { getThundrData, getCopy, getAccessibilityCopy } from 'utils/thundr';

import EditorContent from 'components/editor/content';
import Spinner from 'components/spinner/spinner';

import s from 'components/editor/content.sss';

export default class MovieEditor extends EditorContent {
	// Opt in from a subclass to hold off rendering until thundrData is loaded
	get requiresThundrData() {
		return false;
	}

	get movie() {
		return {
			...this.props.content, // Use merged content for visual display
			id: this.props.data?.id,
			base_movie_id: this.props.data?.base_movie_id,
			placeholder: isPlaceholder(this.props.data),
			status: this.state.status,
			movie_type: getMovieType(this.props.data),
			thundr_id: this.props.data?.thundr_id,
		};
	}

	get isLocalMoviePage() {
		return this.movie?.movie_type === LOCAL_MOVIE_TYPE;
	}

	get homeEntEnabled() {
		const regionSettings = getCurrentRegionSettings();
		return !!regionSettings?.homeEnt && !this.isLocalMoviePage;
	}

	constructor(props) {
		super(props);

		this.state = {
			status: Store.get().movieStatuses?.[this.props.data?.id],
			thundrData: {},
			thundrDataLoading: true,
		};
	}

	componentDidMount() {
		super.componentDidMount?.();

		this.updateMovieStatus();
		this.loadThundrData();
	}

	componentDidUpdate(prevProps) {
		super.componentDidUpdate?.(prevProps);

		if (prevProps.data !== this.props.data) {
			this.updateMovieStatus();
		}

		if (this.thundrDataKey(prevProps.data) !== this.thundrDataKey()) {
			this.loadThundrData();
		}
	}

	// Identifies which deployment `getThundrData` resolves to, so we can tell a real movie change from an edit
	thundrDataKey(data = this.props.data) {
		return `${data?.id}/${data?.thundr_id}/${data?.ready_state}`;
	}

	async loadThundrData() {
		const key = this.thundrDataKey();
		this.setState({ thundrData: {}, thundrDataLoading: true });
		const thundrData = await getThundrData(this.props.data);

		// Discard if we moved on to another movie while loading
		if (this.thundrDataKey() !== key) return;

		this.setState({ thundrData, thundrDataLoading: false });
	}

	async updateMovieStatus() {
		const status = await getMovieStatus(this.props.data);
		this.setState({ status });
	}

	hasFeature(feature) {
		return this.state.thundrData?.dev?.cms?.includedFeatures?.includes(feature);
	}

	text(value, defaultValue) {
		return getCopy(this.state.thundrData, value) || getAccessibilityCopy(this.state.thundrData, value) || defaultValue || value;
	}

	navigateToMedia() {
		const movieId = this.movie?.base_movie_id || this.movie?.id;
		if (movieId) window.location.hash = `movies/${movieId}/media`;
	}

	renderLoading() {
		return <div class={s.loading}><Spinner /></div>;
	}

	render(props) {
		if (this.requiresThundrData && this.state.thundrDataLoading) {
			return this.renderLoading();
		}
		return super.render(props);
	}
}